import { type, value } from '@capital-access/common/user';

export class DefaultSecurityListSettings {
  @value(type.number) id!: number | null;
}
